// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ITitleSourceType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class TitleSourceType implements ITitleSourceType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns MAX TitleSourceType
	**/
    get MAX(): ITitleSourceType {
        return this.FromId(1);
    }
    /**
		Returns ELT TitleSourceType
	**/
    get ELT(): ITitleSourceType {
        return this.FromId(2);
    }
    /**
		Returns DRT TitleSourceType
	**/
    get DRT(): ITitleSourceType {
        return this.FromId(3);
    }
    /**
		Returns AET TitleSourceType
	**/
    get AET(): ITitleSourceType {
        return this.FromId(4);
    }
    /**
		Returns ETT TitleSourceType
	**/
    get ETT(): ITitleSourceType {
        return this.FromId(5);
    }

    get FELT(): ITitleSourceType {
        return this.FromId(6);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'MAX', displayValue: 'MAX', description: 'MAX is any title created by CSRs in the MAX system.', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'ELT', displayValue: 'ELT', description: 'ELT comes from the AADA Electronic Lien Title system.', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'DRT', displayValue: 'DRT', description: 'DRT is from the AADA Dealer Reassignement Title transaction.', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'AET', displayValue: 'AET', description: 'Abandoned Vehicle Electronic Title', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'ETT', displayValue: 'ETT', description: 'Customer-initiated Electronic Title', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'FELT', displayValue: 'FELT', description: 'Financial ELT ', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ITitleSourceType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ITitleSourceType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ITitleSourceType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ITitleSourceType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ITitleSourceType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
